module.exports = __webpack_public_path__ + "static/img/_grjs.918d626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/_grjs.png
// module id = K7tS
// module chunks = 96